<template>
    <div class="type-select" :class="{'is-content': isContent}">
        <p
            v-for="(item,index) in newForm"
            :key="index"
            class="item"
            :class="{active: `${newSelect}` === `${index}`}"
            @click="handleClick(item, index)"
        >
            {{item.name}}
        </p>
    </div>
</template>

<script>
    export default {
        name: "type-select",
        props: {
            form: Array,
            select: [Number,String],
            isContent: Boolean
        },
        watch: {
            select(vl){this.newSelect = vl},
            newSelect(vl){this.$emit('update:select', vl)},
        },
        created(){
            if(!this.select){
                this.handleClick(this.newForm[0], 0)
            }
        },
        data(){
            return {
                newForm: this.form,
                newSelect: this.select
            }
        },
        methods: {
            handleClick(item, index){
                this.newSelect = index
                this.$emit('onTypeSelect', item)
            }
        }
    }
</script>

<style lang="scss" scoped>
.type-select{
    width: 125px;
    position: relative;

    &:before {
        content: '';
        width: 125px;
        height: 100%;
        position: absolute;
        left: 0px;
        /*bottom: -100%;*/
        bottom: -126%;
        background-color: #303133;
        border-bottom-left-radius: 2px;
    }

    &.is-content:before{
        /*bottom: -110%;*/
        bottom: -216%;
    }

    .item{
        font-size:14px;
        color:rgba(153,153,153,1);
        line-height:40px;
        padding: 0px 10px;
        padding-left: 20px;
        cursor: pointer;

        &:hover, &.active{
            background-color: #e7622e;
            color:white;
        }
    }
}
</style>
